import { create } from 'zustand'
import { produce } from 'immer'

interface VehicleCalculations {
  estimatedTime: number
  drivenTime: number
}

interface SchedulerHeaderState {
  calculations: {
    [vehicleId: string]: VehicleCalculations
  }
}

interface SchedulerHeaderActions {
  setEstimatedTime: (vehicleId: string, estimatedTime: number) => void
  setDrivenTime: (vehicleId: string, drivenTime: number) => void
}

export type SchedulerHeaderStore = SchedulerHeaderState & SchedulerHeaderActions

export const useSchedulerCalculationsStore = create<SchedulerHeaderStore>()(set => ({
  calculations: {},
  setEstimatedTime: (vehicleId: string, estimatedTime: number) =>
    set(
      produce((state: SchedulerHeaderState) => {
        if (!state.calculations[vehicleId]) {
          state.calculations[vehicleId] = { estimatedTime: 0, drivenTime: 0 }
        }
        state.calculations[vehicleId].estimatedTime = estimatedTime
      })
    ),
  setDrivenTime: (vehicleId: string, drivenTime: number) =>
    set(
      produce((state: SchedulerHeaderState) => {
        if (!state.calculations[vehicleId]) {
          state.calculations[vehicleId] = { estimatedTime: 0, drivenTime: 0 }
        }
        state.calculations[vehicleId].drivenTime = drivenTime
      })
    ),
}))
